import { loadMessages, locale } from "devextreme/localization";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import english from "./locales/en.json";
import spanish from "./locales/es.json";

import enMessages from "devextreme/localization/messages/en.json";
import esMessages from "devextreme/localization/messages/es.json";

const language = localStorage.getItem("language") ?? "es";

i18n.use(initReactI18next).init({
	fallbackLng: import.meta.env.VITE_I18N_FALLBACK_LOCALE,
	lng: language,
	interpolation: {
		escapeValue: false, // not needed for react as it escapes by default
	},
	//debug: true,
	resources: {
		en: {
			translation: english,
		},
		es: {
			translation: spanish,
		},
	},
	returnEmptyString: true,
	returnNull: false,
});

// Setear el locale de devextreme
loadMessages(language === "es" ? esMessages : enMessages);
locale(language);

export default i18n;
